import React from "react";

import IconButton from "@material-ui/core/IconButton";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";


const ArrowIconButton = ({classes, onClick, dataId}) => {
  return (
    <IconButton data-id={dataId} color={"primary"} className={classes.iconButton} onClick={onClick} disableRipple>
      <i className={"far fa-arrow-right"} />
    </IconButton>
  )
};

export default withStyles(styles)(ArrowIconButton);